var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4,1.6c-1.5-1.5-3.9-1.5-5.4,0L1.6,8.9c-1.5,1.5-1.5,3.9,0,5.4c0.8,0.7,1.7,1.1,2.7,1.1c1,0,2-0.4,2.7-1.1 L12,9.4c0.9-0.9,0.9-2.4,0-3.3c-0.9-0.9-2.4-0.9-3.3,0l-5.2,5.2L4.2,12l5.2-5.2c0.5-0.5,1.4-0.5,1.9,0c0.5,0.5,0.5,1.4,0,1.9 l-4.9,4.9c-1.1,1.1-2.9,1.1-4,0c-1.1-1.1-1.1-2.9,0-4l7.3-7.3c1.1-1.1,2.9-1.1,4,0c1.1,1.1,1.1,2.9,0,4l-0.1,0.1l0.7,0.7l0.1-0.1 C15.9,5.6,15.9,3.1,14.4,1.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.5e6d6beba17d255703fb4810ba24f0e8.svg";
export { ForwardRef as ReactComponent };